<div class="flex flex-column gap-4 pt-2">
  <!-- Shared filters: apply to both the month-range and single-date exports -->
  <div class="flex flex-column gap-3 pb-4 border-bottom-1 surface-border">
    <div class="field flex flex-column gap-2 m-0">
      <label for="creditLocation" class="font-medium text-900 text-sm">Location</label>
      <p-dropdown inputId="creditLocation" [options]="locationOptions()" optionLabel="label"
        optionValue="value" [(ngModel)]="selectedLocationName" [filter]="true" filterBy="label"
        styleClass="w-full" appendTo="body"></p-dropdown>
    </div>

    @if (selectedLocationName == null) {
      <div class="flex align-items-center gap-2">
        <p-checkbox [(ngModel)]="excludeClosed" [binary]="true" inputId="excludeClosed"></p-checkbox>
        <label for="excludeClosed" class="text-900 cursor-pointer">Exclude closed locations</label>
      </div>
    }

    <div class="flex align-items-center gap-2">
      <p-checkbox [(ngModel)]="sortByCountry" [binary]="true" inputId="sortByCountry"></p-checkbox>
      <label for="sortByCountry" class="text-900 cursor-pointer">Group and sort by country</label>
    </div>

    <small class="p-text-secondary m-0 line-height-3">
      Applies to both exports below.
    </small>
  </div>

  <p-tabView styleClass="pup-credit-tabs">
    <!-- Monthly range export -->
    <p-tabPanel header="Month range">
      <div class="flex flex-column gap-4 pt-2">
        <p class="p-text-secondary m-0 line-height-3">
          Generate the PUP Credit sheet totalled across a month range.
        </p>

        <div class="formgrid grid m-0">
          <div class="field col-6 flex flex-column gap-2 pl-0">
            <label for="fromMonth" class="font-medium text-900 text-sm">From month</label>
            <p-dropdown inputId="fromMonth" [options]="months" optionLabel="name" optionValue="key"
              [(ngModel)]="fromMonth" styleClass="w-full" appendTo="body"></p-dropdown>
          </div>
          <div class="field col-6 flex flex-column gap-2 pr-0">
            <label for="toMonth" class="font-medium text-900 text-sm">To month</label>
            <p-dropdown inputId="toMonth" [options]="months" optionLabel="name" optionValue="key"
              [(ngModel)]="toMonth" styleClass="w-full" appendTo="body"></p-dropdown>
          </div>
        </div>

        <div class="field flex flex-column gap-2 m-0">
          <label for="year" class="font-medium text-900 text-sm">Year</label>
          <p-dropdown inputId="year" [options]="years" [(ngModel)]="year"
            styleClass="w-full" appendTo="body"></p-dropdown>
        </div>

        <div class="flex align-items-center gap-2">
          <p-checkbox [(ngModel)]="includeLockerTotalBookings" [binary]="true"
            inputId="lockerTotals"></p-checkbox>
          <label for="lockerTotals" class="text-900 cursor-pointer">Add a Locker Total Bookings sheet</label>
        </div>

        <div class="flex align-items-center gap-2">
          <p-checkbox [(ngModel)]="separateDailyMonthly" [binary]="true"
            inputId="separateDailyMonthly"></p-checkbox>
          <label for="separateDailyMonthly" class="text-900 cursor-pointer">Break down locker credit by type</label>
        </div>

        @if (errorMessage) {
          <small class="flex align-items-center gap-2 text-red-500">
            <i class="pi pi-exclamation-circle"></i>{{ errorMessage }}
          </small>
        }

        <div class="flex justify-content-end gap-2 mt-2">
          <p-button label="Close" [text]="true" severity="secondary" class="font-medium"
            (onClick)="close()"></p-button>
          <button pButton type="button" class="p-button-raised font-medium" (click)="generate()">
            Generate sheet
          </button>
        </div>
      </div>
    </p-tabPanel>

    <!-- Credit balance as of a date -->
    <p-tabPanel header="At a date">
      <div class="flex flex-column gap-4 pt-2">
        <p class="p-text-secondary m-0 line-height-3">
          Export each PUP's credit recorded on the chosen day.
        </p>

        <div class="field flex flex-column gap-2 m-0">
          <label for="creditDate" class="font-medium text-900 text-sm">Date</label>
          <p-calendar inputId="creditDate" [(ngModel)]="selectedDate" [maxDate]="maxDate"
            dateFormat="yy-mm-dd" [showIcon]="true" styleClass="w-full" appendTo="body"></p-calendar>
        </div>

        @if (exportErrorMessage) {
          <small class="flex align-items-center gap-2 text-red-500">
            <i class="pi pi-exclamation-circle"></i>{{ exportErrorMessage }}
          </small>
        }

        <div class="flex justify-content-end gap-2 mt-2">
          <p-button label="Close" [text]="true" severity="secondary" class="font-medium"
            (onClick)="close()"></p-button>
          <button pButton type="button" class="p-button-raised font-medium" (click)="exportAtDate()">
            Export sheet
          </button>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
